import './index.scss';
import { lang } from '@umu/ukit-lang';
import React, { useState } from 'react';
import { Button, Modal, SnackBar } from '@umu/umu-design';
import { ModalFuncProps } from '@umu/umu-design/es/components/Modal';
import { ITransferData, TransformInput } from './transformInput';
import { getAccessCodesWithoutRemoveMiddleSpace } from './dataFlow';

type BtnType =
    | 'link'
    | 'text'
    | 'primary'
    | 'default'
    | 'primary-blue'
    | 'ghost'
    | 'ghost-blue'
    | 'ghost-grey'
    | 'text-grey'
    | 'dark-mode'
    | undefined;
interface IBatchProps {
    prefix?: string;
    className?: string;
    inputTitleText?: string | JSX.Element;
    preViewTitleText?: string | JSX.Element;
    emptyText?: string;
    submitBtnText?: string;
    submitBtnType?: BtnType;
    previewBtnText?: string;
    previewBtnType?: BtnType;
    previewPlaceholder?: string;
    onLoadData?: (value: string) => Promise<ITransferData[]>;
    onSubmit?: (list: ITransferData[]) => void;
    onPreview?: (value: string, callBack: (list: ITransferData[]) => void) => void;
}
const { confirm } = Modal;
const BatchAddAccount = (props: IBatchProps) => {
    const {
        prefix = 'umu-batch-add-account-panel-info',
        className = '',
        previewBtnType = 'primary-blue',
        submitBtnType = 'primary-blue',
        previewBtnText = lang('预览'),
        preViewTitleText = lang('预览'),
        submitBtnText = lang('确认添加'),
        emptyText = lang('未输入成员信息'),
        inputTitleText = lang('用逗号或回车分隔'),
        previewPlaceholder = lang(
            '请输入成员账户信息（邮箱、手机号、用户名）、班级名或分组名，用逗号或回车分隔，输入完成后点击下方“预览”按钮查看。',
        ),
    } = props;

    const [codeValue, setCodeValue] = useState<string>('');
    const [codeList, setCodeList] = useState<ITransferData[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const getReviewAccountList = (value: string, callBack: VoidFunction) => {
        props.onPreview &&
            props.onPreview(value, (list) => {
                setCodeList(list);
                callBack();
            });
        setCodeList([]);
    };
    const onPreviewClick = () => {
        let value = codeValue.trim();

        value = getAccessCodesWithoutRemoveMiddleSpace(value);
        if (value === '') {
            SnackBar.show({
                message: emptyText,
            });
            return;
        }
        if (!value) {
            return;
        }
        setIsLoading(true);
        getReviewAccountList(value, () => {
            setIsLoading(false);
        });
    };
    const onSubmitClick = () => {
        props.onSubmit?.(codeList);
    };
    return (
        <div className={`${prefix} ${className}`}>
            <div className={`${prefix}-content`}>
                <TransformInput
                    className={`${prefix}-content-transform`}
                    title={inputTitleText}
                    isEditor
                    defaultValue={codeValue}
                    onChange={setCodeValue}
                    textPlaceholder={previewPlaceholder}
                />
                <div className={`${prefix}-split-zone`} />
                <TransformInput
                    className={`${prefix}-content-transform`}
                    title={preViewTitleText}
                    isLoading={isLoading}
                    data={codeList}
                />
            </div>
            <div className={`${prefix}-footer`}>
                <Button
                    type={previewBtnType}
                    loading={isLoading}
                    disabled={!(codeValue || '').trim().length || isLoading}
                    className="btn-split-right"
                    onClick={onPreviewClick}
                >
                    {isLoading ? '' : previewBtnText}
                </Button>
                <Button type={submitBtnType} disabled={!codeList.length || isLoading} onClick={onSubmitClick}>
                    {submitBtnText}
                </Button>
            </div>
        </div>
    );
};
/*************批量添加弹窗函数***************/
interface IBatchDialogInfo {
    title?: string;
    dialogProps?: ModalFuncProps;
    batchProps: IBatchProps;
}
const onBatchAddAccountDialog = (data: IBatchDialogInfo) => {
    const { title, batchProps, dialogProps } = data;
    return confirm({
        centered: true,
        width: 'auto',
        footer: null,
        zIndex: 99999,
        title: title || lang('批量新增成员'),
        content: <BatchAddAccount {...batchProps} />,
        ...dialogProps,
    } as any);
};
export { IBatchProps, BatchAddAccount, TransformInput, onBatchAddAccountDialog };
